export const PRODUCT_REVIEW_TAB_INDEX = Object.freeze({
  BASE_DATA: 0,
  MEDIA: 1,
  DISPLAY: 2,
  BRAND_AND_CATEGORY: 3,
  TAXES_AND_SALES: 4,
})
